
import {MainHeading, MainContainer,FrontendImage,ContainerOne,ContainerTwo,IconsContainer,IconsMainConatiner,LargeDeviceContainer } from './styledComponents'
import {AiFillGithub} from 'react-icons/ai'
const Home = () =>{
    const style = { fontSize: "70px", color:'#ffffff' };
    return(
        <MainContainer id="homeSection">
            
            <LargeDeviceContainer>
            <ContainerOne>
                <MainHeading color="#ffffff">Hi, My name is Mani Charan Reddy Gade</MainHeading>
                <MainHeading color="#8c8a84">I am a FullStack Developer</MainHeading>
                <IconsMainConatiner>
                    
                <IconsContainer href="https://github.com/manicharan-12" target="_blank">
                <AiFillGithub style={style}/>
                </IconsContainer>
                </IconsMainConatiner>
                
            </ContainerOne>
            <ContainerTwo>
                <FrontendImage src="https://res.cloudinary.com/djovsq3xl/image/upload/v1686469165/programming-concept-illustration_114360-1351-removebg-preview_zpjqqj.png" alt="working"/>
            </ContainerTwo>
            </LargeDeviceContainer>
        </MainContainer>
    )
}


export default Home
